import { TwoDWaterflowConfig } from "@nens/deck-gl";

import { AppState } from "../App";

export interface WaterflowConfig {
  visible: boolean;
  color: string;
  speedPercentage: number;
  waterflowThreshold: number;
  waterflowHighlightThreshold: number;
}

interface LayerCalculationMenu {
  modelGridLayerOpen: boolean;
  modelGridFlowLayerOpen: boolean;
  flowSpeedLayer: WaterflowConfig;
  twoDFlowSpeedLayer: TwoDWaterflowConfig;
  waterdepthLayerOpen: boolean;
}

const INITIAL_STATE: LayerCalculationMenu = {
  modelGridLayerOpen: false,
  modelGridFlowLayerOpen: true,
  flowSpeedLayer: {
    visible: true,
    color: "#FFFFFF",
    speedPercentage: 50,
    waterflowThreshold: 0.1,
    waterflowHighlightThreshold: 2,
  },
  twoDFlowSpeedLayer: {
    visible: true,
    disabled: false,
    amountPercentage: 50,
    speedPercentage: 50,
    sizePercentage: 50,
    waterflowThreshold: 0.1,
    color: "#5ABAFF",
  },
  waterdepthLayerOpen: true,
};

export const getModelGridLayerOpen = (state: AppState) =>
  state.layerCalculationMenu.modelGridLayerOpen;
export const getModelGridFlowLayerOpen = (state: AppState) =>
  state.mainGui.activeTool === "LEVEE_TOOL" &&
  state.leveeEdit["status"] === "DRAWING_MODE" &&
  state.layerCalculationMenu.modelGridFlowLayerOpen;
export const getTwoDFlowSpeedLayer = (state: AppState) =>
  state.layerCalculationMenu.twoDFlowSpeedLayer;

export const getFlowSpeedLayer = (state: AppState) => state.layerCalculationMenu.flowSpeedLayer;
export const getWaterdepthLayerOpen = (state: AppState) =>
  state.layerCalculationMenu.waterdepthLayerOpen;

const SET_MODEL_GRID_LAYER_OPEN = "LayerCalculationMenu/SET_MODEL_GRID_LAYER_OPEN";
const SET_MODEL_GRID_FLOW_LAYER_OPEN = "LayerCalculationMenu/SET_MODEL_GRID_FLOW_LAYER_OPEN";
const SET_FLOW_SPEED_LAYER = "LayerCalculationMenu/SET_FLOW_SPEED_LAYER";
const SET_TWO_D_FLOW_SPEED_LAYER = "LayerCalculationMenu/SET_TWO_D_FLOW_SPEED_LAYER";
const SET_WATER_DEPTH_LAYER_OPEN = "LayerCalculationMenu/SET_WATER_DEPTH_LAYER_OPEN";

interface SetModelGridLayerOpen {
  type: typeof SET_MODEL_GRID_LAYER_OPEN;
  open: boolean;
}
interface SetModelGridFlowLayerOpen {
  type: typeof SET_MODEL_GRID_FLOW_LAYER_OPEN;
  open: boolean;
}
interface SetFlowSpeedLayer {
  type: typeof SET_FLOW_SPEED_LAYER;
  flowSpeedLayer: WaterflowConfig;
}
interface SetTwoDFlowSpeedLayer {
  type: typeof SET_TWO_D_FLOW_SPEED_LAYER;
  twoDFlowSpeedLayer: TwoDWaterflowConfig;
}
interface SetWaterDepthLayerOpen {
  type: typeof SET_WATER_DEPTH_LAYER_OPEN;
  open: boolean;
}

export const setModelGridLayerOpen = (open: boolean) => {
  return {
    type: SET_MODEL_GRID_LAYER_OPEN,
    open,
  };
};

export const setModelGridFlowLayerOpen = (open: boolean) => {
  return {
    type: SET_MODEL_GRID_FLOW_LAYER_OPEN,
    open,
  };
};

export const setFlowSpeedLayer = (flowSpeedLayer: Partial<WaterflowConfig>) => {
  return {
    type: SET_FLOW_SPEED_LAYER,
    flowSpeedLayer,
  };
};

export const setTwoDFlowSpeedLayer = (twoDFlowSpeedLayer: Partial<TwoDWaterflowConfig>) => {
  return {
    type: SET_TWO_D_FLOW_SPEED_LAYER,
    twoDFlowSpeedLayer,
  };
};

export const setWaterDepthLayerOpen = (open: boolean) => {
  return {
    type: SET_WATER_DEPTH_LAYER_OPEN,
    open,
  };
};

type LayerCalculationMenuAction =
  | SetModelGridLayerOpen
  | SetModelGridFlowLayerOpen
  | SetFlowSpeedLayer
  | SetTwoDFlowSpeedLayer
  | SetWaterDepthLayerOpen;

export default function reducer(state = INITIAL_STATE, action: LayerCalculationMenuAction) {
  switch (action.type) {
    case SET_MODEL_GRID_LAYER_OPEN: {
      // use acoulades for block scoping the consts status message
      return {
        ...state,
        modelGridLayerOpen: action.open,
      };
    }
    case SET_MODEL_GRID_FLOW_LAYER_OPEN: {
      return {
        ...state,
        modelGridFlowLayerOpen: action.open,
      };
    }
    case SET_FLOW_SPEED_LAYER: {
      return {
        ...state,
        flowSpeedLayer: { ...state.flowSpeedLayer, ...action.flowSpeedLayer },
      };
    }
    case SET_TWO_D_FLOW_SPEED_LAYER: {
      return {
        ...state,
        twoDFlowSpeedLayer: { ...state.twoDFlowSpeedLayer, ...action.twoDFlowSpeedLayer },
      };
    }
    case SET_WATER_DEPTH_LAYER_OPEN: {
      return {
        ...state,
        waterdepthLayerOpen: action.open,
      };
    }
    default:
      return state;
  }
}
